import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiClient } from '../core/api-client.service';
import { DumbAdmin } from './DTOs/dumb-admin';
import { Observable } from 'rxjs';
import { SaveAdminRequest } from './DTOs/save-admin-request';
import { GetAdminsRequest } from './DTOs/get-admins-request';
import { AdminDtRetInfo } from './DTOs/admin-dt-ret-info';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminService {
    readonly relativeBase = "super-admin-management/";

    constructor(private http: ApiClient) {

    }
    getmyAdminInfo(): Observable<DumbAdmin> {
      return this.http.get(this.relativeBase + "who-am-i");
    }
    getAllSuperAdmins(request: GetAdminsRequest): Observable<AdminDtRetInfo> {
      return this.http.post(this.relativeBase + "get-all", request);
    }
    CreateNewSuperAdmin(request: SaveAdminRequest) {
      return this.http.put(this.relativeBase + "create", request);
    }
    UpdateSuperAdmin(request: SaveAdminRequest) {
      return this.http.post(this.relativeBase + "update", request);
    }
    SendAdminPasswordReset(contactId: string) {
      return this.http.post(this.relativeBase + "send-passord-reset/" + contactId, null);
    }

}
